/**
 * Política de búsqueda de productos (catálogo, inventario, informes).
 */
export const MIN_PRODUCT_SEARCH_QUERY_CHARS = 3;
export const PRODUCT_SEARCH_DEBOUNCE_MS = 280;

/** Solo aplica texto al listado / remoto cuando alcanza el mínimo (vacío = sin filtro por texto). */
export function effectiveProductSearchQuery(trimmedDebouncedDraft: string): string {
  return trimmedDebouncedDraft.length >= MIN_PRODUCT_SEARCH_QUERY_CHARS ? trimmedDebouncedDraft : '';
}

/** Empty state under the product search. Don't mention SCAN if the button isn't there. */
export function productSearchEmptyMessage(scanAvailable: boolean): string {
  return scanAvailable
    ? 'No hay ítems que coincidan. Probá otro texto o usá SCAN con el código.'
    : 'No hay ítems que coincidan. Probá otro nombre o código.';
}
